<template>
  <div>
    <div class="wrapper-report-connection bg-bad" v-if="!ol">
      <div class="d-flex justify-content-between">
        <div class="conection-item d-flex align-items-end">
          <div class="icon">
            <img src="@/assets/icons/wifi-off.svg" alt="">
          </div>
          <div class="f-regular f-c-red f-12 m-l-8">Offline</div>
        </div>
      </div>
    </div>

    <template v-else>
      <div class="wrapper-report-connection" v-if="connection.data">
        <div class="d-flex justify-content-between">
          <div class="conection-item d-flex align-items-end">
            <div class="icon">
              <img src="@/assets/icons/wifi-4-bar.svg" v-if="ol && connection.data[idMesin].rssi >= -30" alt="">
              <img src="@/assets/icons/wifi-3-bar.svg" v-else-if="ol && connection.data[idMesin].rssi >= -67" alt="">
              <img src="@/assets/icons/wifi-2-bar.svg" v-else-if="ol && connection.data[idMesin].rssi >= -70" alt="">
              <img src="@/assets/icons/wifi-1-bar.svg" v-else-if="ol && connection.data[idMesin].rssi >= -80" alt="">
              <img src="@/assets/icons/wifi-off.svg" v-if="!ol" alt="">
            </div>
            <div class="f-regular f-c-black f-12 m-l-8">
              {{ connection.data[idMesin].ssid }}
            </div>
          </div>
          <img src="@/assets/icons/alert-circle-gray.svg" v-if="connection.data[idMesin].rssi < -67"
               class="justify-self-end" alt="">
        </div>
        <div class="f-12 f-c-midgrey f-regular mt-1" v-if="connection.data[idMesin].rssi < -67">
          Sinyal lemah, mohon dekatkan mesin dengan router WiFi yang Anda gunakan.
        </div>
      </div>
      <div class="ph-item mb-0 bg-good p-y-8" v-else>
        <div class="ph-col-6 p-0">
          <div class="ph-row m-0">
            <div class="ph-col-2 big mr-2 mb-0"></div>
            <div class="ph-col-8 big mb-0"></div>
          </div>
        </div>
        <div class="ph-col-6 p-0">
          <div class="ph-row m-0">
            <div class="ph-col-2 big mb-0 ml-auto"></div>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  name: "SOConnectionStatus",
  props: {
    ol: Boolean,
    connection: Object || Array,
    idMesin: String
  }
}
</script>

<style scoped>
.wrapper-report-connection {
  background: #FFFFFF;

  align-items: center;
  padding: 8px 20px;
}

.bg-bad {
  background: linear-gradient(90deg, #FFE6E6 0%, #FFFFFF 50%), #FFFFFF;
}
</style>